import { ReduxUtils } from '../../../dependencies';
import { types } from '../../actions';

const actionTypes = {
    REQUEST: types.DELETE_EXPORT_REQUEST,
    SUCCESS: types.DELETE_EXPORT_SUCCESS,
    FAILURE: types.DELETE_EXPORT_FAILURE,
    CANCEL: types.DELETE_EXPORT_CANCEL,
};

const apiReducer = ReduxUtils.basicApiReducer({
    actionTypes,
});

export default ReduxUtils.containerReducer({
    childReducer: apiReducer,
    actionTypes: Object.values(actionTypes),
    selectors: {
        itemId: action => action.meta.id,
    },
});
